import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { Control, useController } from 'react-hook-form';
import FormError from '../../form-error/FormError';
import { Timezone } from '../../types';

export interface TimezoneFieldProps {
  control: Control<any>;
  name: string;
  timezones: Timezone[];
}

const TimezoneField = ({ control, name, timezones }: TimezoneFieldProps) => {
  const {
    field: { value, ...field },
    fieldState: { error },
    formState,
  } = useController({
    control,
    name,
    rules: { required: 'Please provide a time zone' },
  });

  return (
    <FormControl fullWidth error={!!error}>
      <InputLabel required>Time zone</InputLabel>

      <Select
        {...field}
        MenuProps={{
          PaperProps: { sx: { maxHeight: 240 } } /* About 6.5 item */,
        }}
        label="Timezone"
        value={timezones.length ? value : ''}
      >
        {timezones.map(({ id, name }) => (
          <MenuItem key={id} value={id}>
            {name}
          </MenuItem>
        ))}
      </Select>

      <FormError formState={formState} name={name} />
    </FormControl>
  );
};

export default TimezoneField;
